import config from 'controllers/config';
import { IQuestionnaireRequestData } from 'pages/formsCreate/types';
import { useCallback, useState } from 'react';
import { useApi } from 'services/api';

interface IGetFormDataParams {
  id: number;
  supplierId?: number;
}

export const useFormData = () => {
  const { api } = useApi();

  const [formData, setFormData] = useState<IQuestionnaireRequestData>();
  const [isLoadingFormData, setIsLoadingFormData] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const getFormData = useCallback(async ({ id, supplierId }: IGetFormDataParams) => {
    const backendUrl = config.API_NODE;

    if (backendUrl) {
      const headers = { userfunctionkey: 'c80a0ae7cdf09e28c72e949ee37df341' };
      const { data } = await api.get<IQuestionnaireRequestData>(`${backendUrl}/forms/${id}`, {
        headers,
        params: { supplierId }
      });
      return data;
    }
  }, []);

  const loadFormData = useCallback(({ id, supplierId }: IGetFormDataParams) => {
    if (!id) return;

    setIsLoadingFormData(true);
    getFormData({ id, supplierId })
      .then(setFormData)
      .finally(() => setIsLoadingFormData(false));
  }, []);

  return { loadFormData, formData, isLoadingFormData, isModalOpen, setIsModalOpen };
};
